import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=5689ce48"
import script from "./fullScreen.vue?vue&type=script&lang=js"
export * from "./fullScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports